import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { ClienteFincaLoteResponse } from "../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { AnalisisLaboratorioResponse } from "../../../../modulos/fertilizacion/response/AnalisisLaboratorioResponse";
import {
  AsignarLotesRequest,
  fx_createAsignarLotesRequestEmpty,
} from "../../../../modulos/fertilizacion/request/AsignarLotesRequest";
import { fx_createFertilizacionAsignarLotesGrpcService } from "../../../../modulos/fertilizacion/services/FertilizacionAsignarLotesGrpcService";
import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { BaseFullScreenFormModalRender } from "../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../definitions/form/IFormBodyRender";
import { FertilizacionValidacionFormRender } from "../list/FertilizacionValidacionFormRender";

/** Modal a pantalla completa de registro de lotes: la tabla de validación de un
 *  análisis (asignar a mano los registros pendientes). Al "Guardar asignaciones"
 *  manda el batch (`POST /{analisisId}/asignar-lotes`), cierra y recarga la
 *  página — al re-montar, el chequeo de pendientes de `FertilizacionPage` toma
 *  el siguiente análisis pendiente (cola de a uno). */
export class FertilizacionRegistroLotesModalRender extends BaseFullScreenFormModalRender<
  AsignarLotesRequest,
  AnalisisLaboratorioResponse
> {
  protected readonly elementId = "fertilizacionRegistroLotesModal";

  /**
   * @param _analisis Análisis cuyos lotes se registran.
   * @param _lotes    Lotes de la finca (opciones del selector).
   */
  constructor(
    private readonly _analisis: AnalisisLaboratorioResponse,
    private readonly _lotes: ClienteFincaLoteResponse[],
  ) {
    super(fx_createAsignarLotesRequestEmpty());
  }

  protected get title(): string {
    return "Registro de lotes";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().get()?.nombreFinca;
  }

  protected get saveLabel(): string {
    return "Guardar asignaciones";
  }

  protected getFormBody(): IFormBodyRender {
    return new FertilizacionValidacionFormRender(
      this._request,
      this._analisis,
      this._lotes,
    );
  }

  protected get saveService(): ISaveService<
    AsignarLotesRequest,
    AnalisisLaboratorioResponse
  > {
    return fx_createFertilizacionAsignarLotesGrpcService(this._analisis.id);
  }
}
